import "./src/css/style.css";

export const onServiceWorkerUpdateReady = () => window.location.reload(true);